// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"bb43acfd888cca65f6c0","310":"33bac903a374580de4c7"}[chunkId] + ".js";
};